import React from 'react';
import styled, { keyframes } from 'styled-components';
import ChevronDown from '@panel/commons/assets/icons/ChevronDown.svg';
import ChevronUp from '@panel/commons/assets/icons/ChevronUp.svg';

const DropDown = ({ title, isOpen, setIsOpen, children }) => {
  return (
    <Container>
      <Header>
        <Title>{title}</Title>
        <Chevron
          onClick={e => {
            e.stopPropagation();
            setIsOpen(!isOpen);
          }}
          isOpen={isOpen}
        />
      </Header>
      <ContentArea isOpen={isOpen}>{children}</ContentArea>
    </Container>
  );
};

export default DropDown;

const Container = styled.div`
  width: 100%;
  height: fit-content;
  margin: 18px 0;
`;

const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.div`
  font-family: Hind;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
`;

const Chevron = styled.button`
  background-image: ${({ isOpen }) => `url(${isOpen ? ChevronUp : ChevronDown})`};
  width: 24px;
  height: 24px;
  background-size: cover;
  background-repeat: no-repeat;
  cursor: pointer;
  margin-right: 8px;
`;

const growDown = keyframes`
  0% {
    height:0px;
  }
  100% {
    height: 130px;
  }
`;

const ContentArea = styled.div`
  width: 100%;
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  animation: ${growDown} 300ms ease-in-out;
  overflow: hidden;
`;
